document.addEventListener("DOMContentLoaded", function () {
    const btn = document.querySelector(".search-btn");
    const modal = document.querySelector(".search-modal");

    btn?.addEventListener("click", e => {
        e.preventDefault();
        modal.classList.toggle("active");
        btn.classList.toggle("active");
        modal.querySelector("input[name='q']")?.focus();
    });
});
